import React from 'react';
import { useTranslation } from '../../context/LanguageContext';

const ToggleSwitch = ({ checked, onChange, name }) => {
    const { t, language } = useTranslation();
    const isRTL = language === 'ar';

    return (
        <div className="flex items-center h-full">
            <label className="relative inline-flex items-center cursor-pointer">
                <input
                    type="checkbox"
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 
                    peer-focus:ring-yellow-300 rounded-full peer 
                    peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full 
                    peer-checked:after:border-white after:content-[''] after:absolute 
                    after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 
                    after:border after:rounded-full after:h-5 after:w-5 after:transition-all 
                    peer-checked:bg-yellow-500"
                />
                <span className={`${isRTL ? 'mr-3' : 'ml-3'} text-sm font-medium text-gray-700`}>
                    {checked ? t('admin:categoryActive') : t('admin:categoryInactive')}
                </span>
            </label>
        </div>
    );
};

export default ToggleSwitch;
